/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Pressable, View, Text, LargeCloseIcon } from '@components/atoms'
import { grey } from '@mui/material/colors'

interface PropsType {
	onBackClick: () => void
}

export const ForgotPasswordMessage = (props: PropsType) => {
	const onBackClick = () => {
		props.onBackClick()
	}

	return (
		<View css={style}>
			<View
				className="forgotPasswordTextView"
				css={{ borderLeft: `1px solid ${grey[600]}` }}
			>
				<Pressable className="largeCloseButton" onClick={onBackClick}>
					<LargeCloseIcon />
				</Pressable>
				<Text category="h3" hint="800" className="forgotPasswordTitle">
					패스워드를 잊어버리셨군요.
				</Text>
				<Text hint="700" category="p2">
					본 시스템 계정은 (주)넥센 그룹웨어 계정(AD 계정)과 동일합니다.
				</Text>
				<Text className="forgotPasswordContent" hint="700" category="p2">
					1. 사용중인 사내 컴퓨터의 패스워드를 확인하세요.
				</Text>
				<Text className="forgotPasswordContent" hint="700" category="p2">
					2. 컴퓨터 패스워드를 변경해보세요.
				</Text>
				<Text className="forgotPasswordContent" hint="700" category="p2">
					3. 그래도 해결이 되지 않는다면 문의바랍니다.
				</Text>
			</View>
		</View>
	)
}

const style = css({
	position: 'relative',
	zIndex: '10',
	display: 'flex',
	flex: '1',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100%',
	height: '100%',
	paddingTop: '8rem',
	minHeight: '14rem',
	textAlign: 'left',

	'.forgotPasswordTextView': {
		position: 'relative',
		width: '30rem',
		height: '14rem',
		marginBottom: '10rem',
		padding: '1rem 4rem',

		'.forgotPasswordTitle': {
			marginBottom: '3rem',
		},

		'.forgotPasswordContent': {
			paddingLeft: '1rem',
		},

		'.largeCloseButton': {
			position: 'absolute',
			top: '-7rem',
			right: '-5rem',

			'.largeCloseButtonIcon': {
				fontSize: 90,
				color: grey[600],
				textStroke: '1px #fff',
			},
		},
	},
})
